import { render, staticRenderFns } from "./AutomateLinkRow.vue?vue&type=template&id=4f0c3337&scoped=true&"
import script from "./AutomateLinkRow.vue?vue&type=script&lang=ts&"
export * from "./AutomateLinkRow.vue?vue&type=script&lang=ts&"
import style0 from "./AutomateLinkRow.vue?vue&type=style&index=0&id=4f0c3337&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c3337",
  null
  
)

export default component.exports